import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL } from '../utils/common';

const Market_stall_search  = () => {
  const [SexualService, setSexualService] = React.useState(false);
  const [SexualService1, setSexualService1] = React.useState(false);
  const [SexualService2, setSexualService2] = React.useState(false);

  const SexualServiceToggle = () => {
    setSexualService(!SexualService);
  };
  const SexualServiceToggle1 = () => {
    setSexualService1(!SexualService1);
  };
  const SexualServiceToggle2 = () => {
    setSexualService2(!SexualService2);
  };
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
  <div className="social-media wow slideInDown" style={{ visibility: "visible", animationName: "slideInDown" }}>
        <div className="facebook" rel="ebInfo" title="facebook">
          <a href="https://www.facebook.com/KolkataMunicipalCorporation.official" target="_blank">
            <img src="assets/img/face-book-1.png" alt="alt-image" />
          </a>
        </div>
        <div className="twitter" rel="ebInfo" title="Twitter">
          <a href="https://twitter.com/kmc_kolkata" target="_blank">
            <img src="assets/img/twitter1.png" alt="alt-image" />
          </a>
        </div>
        <div className="support" rel="ebInfo" title="KMC Support">
          <a href={`${mainURL}/KMCPortal/jsp/ContactDept.jsp`} target="_blank">
            <img src="assets/img/support.png" alt="alt-image" />
          </a>
        </div>
        <div className="whatsapp" rel="ebInfo" title="Whatsapp">
          <Link to="/Wathsapp" target="_blank">
            <img src="assets/img/social-media.png" alt="alt-image" />
          </Link>
        </div>
      </div>
  
    <div className="carousel-item active">
      <img src="assets/img/Banner/portal-banner8.jpg" className="img-fluid" alt="image" />
      <div className="container">
        
        <div className="section-main-heading2">
          
          <h4 className="fontSizeClass"> </h4>
        </div>
      </div>
    </div>
  </section>
  <section className="section inner-pad1">
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
        <div className="site-menu  min-height-400">
            <nav className="sidebar card py-2">
            <ul className="nav flex-column" id="nav_accordion">
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/KMC_market_list'> {t("List of KMC Markets")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Download_market_fire_fighting_video'> {t("Download Market Fire-Fighting Video")} </Link>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/KMCCollegeStMarketList.jsp' target="_blank"> {t("College Street Market")} </a>
                {/* <Link className="nav-link active1 fontSizeClass" to='/College_street_market_details'> College Street Market </Link> */}
                </li>
                <li className="nav-item">
                  <a className="nav-link fontSizeClass" onClick={(e)=>('')}> {t("Rates & Charges")} </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MarketDemandView.jsp' target="_blank"> {t("Check Demands Payable")} </a>
                  {/* <Link className="nav-link fontSizeClass" to='/Market_Check_demands_payable'> Check Demands Payable</Link> */}
                </li>
                <li className="nav-item">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo">{t("Check Demands Payable")}<i className="bi bi-chevron-down" /></button>
                      <div id="demo" className="collapse">                        
                      <a className="dropdown-item" href='https://www.kmcgov.in/KMCPortal/jsp/MarketPayment.jsp'> {t("Regular Demand")} </a>
                    <a className="dropdown-item" href='https://www.kmcgov.in/KMCPortal/jsp/MarketMiscPayDemand.jsp'> {t("Misclennious Demand")} </a>
                      </div>
                </li>
                <li className="nav-item">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo1">{t("Make Online Payment")}<i className="bi bi-chevron-down" /></button>
                      <div id="demo1" className="collapse">                        
                        <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MarketPayment.jsp'> {t("Regular Demand")} </a>
                        <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MarketMiscPayDemand.jsp'> {t("Misclennious Demand")} </a>
                      </div>
                </li>
                <li className="nav-item">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo2">{t("Reprint e-receipt")}<i className="bi bi-chevron-down" /></button>
                      <div id="demo2" className="collapse">                        
                        <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MarketDuplicateReceipt.jsp'> {t("Regular Demand")} </a>
                        <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MarketMiscDuplicateReceipt.jsp'> {t("Misclennious Demand")} </a>
                      </div>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Make_online_payment'> {t("Make Online Payment")}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Market_list_of_e_receipts'> {t("Reprint e-Receipt")} </Link>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" onClick={(e)=>('')}> {t("Don't be cheated into the market")}. </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" onClick={(e)=>('')}> {t("This is for you, kindly read this")}. </a>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Maps_of_market'> {t("Maps of deep tubewells situated in the market area for fire fighting")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link active1 fontSizeClass" to='/Tender'> {t("Tender")} </Link>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" onClick={(e)=>('')}> {t("KMC Market Stall Details")}.. </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass active1" href='https://www.kmcgov.in/KMCPortal/jsp/KMCMarketStallSearch.jsp' target="_blank"> {t("KMC Market Stall Search")} </a>
                 {/* <Link className="nav-link fontSizeClass" to='/Market_stall_search'> KMC Market Stall Search </Link> */}
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Market_Dept'>{t("Contact Details")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Water_For_Fire_Fighter'> {t("Water For Fire Fighters")} </Link>              
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" onClick={(e)=>('')}> {t("Notice regarding Demolition of Stalls in Marcus Squar")} </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="container">
            <div className="row">
              <div className="inner-title2">
                <h3 className="fontSizeClass"> {t("Search Your Stall/Slab")}</h3>
              </div>
              <div className="about-head1">
                <div className="dig-login1 dig-login2">
                  <form>
                    <div className="log-form inner-log-form">
                      <h3 className="fontSizeClass"> {t("Market Details")} </h3>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            
                            {t("Market Name")}*:
                          </label>
                          <select
                            className="form-control"
                            id="exampleFormControlSelect1"
                          >
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                          </select>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            
                            {t("Phase")}*:
                          </label>
                          <select
                            className="form-control"
                            id="exampleFormControlSelect1"
                          >
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                          </select>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            
                            {t("Block")}*:
                          </label>
                          <select
                            className="form-control"
                            id="exampleFormControlSelect1"
                          >
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                          </select>
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <div className="form-group continu">
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label"
                            >
                              
                              &nbsp;
                            </label>
                            <button className="btn btn-primary" type="button" style={{marginTop:"40px"}}>
                              
                              {t("Search")}
                            </button>
                            <button className="btn btn-primary" type="button"style={{marginTop:"40px"}}>
                              
                              {t("Close")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

  )
}

export default Market_stall_search